import { Navigate, useMatch } from 'react-router';

import { useCurrentUser } from '../../hooks/useCurrentUser';
import { canAccessUser, canAccessUserAccessControl, canManageUsers } from '../../utils/userAccessControlPermissions';
import { userAccessRoutes } from '../../utils/userAccessRoutes';
import { CreateUserFormView } from '../create-user-form/CreateUserFormView';
import { EditUserFormView } from '../edit-user-form/EditUserFormView';
import { UserDetailsView } from '../user-details/UserDetailsView';
import { UserList } from '../user-list/UserList';

function CreateUserForm() {
  const userCtx = useCurrentUser();

  if (!canManageUsers(userCtx?.user)) {
    return <Navigate to={userAccessRoutes.root} replace />;
  }

  return <CreateUserFormView />;
}

function EditUserForm({ userId }: { userId: number }) {
  const userCtx = useCurrentUser();
  if (!canAccessUser(userId, userCtx?.user)) {
    return <Navigate to={userAccessRoutes.root} replace />;
  }

  return <EditUserFormView userId={userId} isSelfService={!canManageUsers(userCtx?.user)} />;
}

function UserDetailsRoute({ userId }: { userId: number }) {
  const userCtx = useCurrentUser();

  if (!canAccessUser(userId, userCtx?.user)) {
    return <Navigate to={userAccessRoutes.root} replace />;
  }

  return <UserDetailsView userId={userId} />;
}

export function UserAccessControlRoutes() {
  const userCtx = useCurrentUser();
  const createUserMatch = useMatch(userAccessRoutes.createUser);
  const editUserMatch = useMatch(userAccessRoutes.editUserPattern);
  const userDetailsMatch = useMatch(userAccessRoutes.userDetailsPattern);

  if (!canAccessUserAccessControl(userCtx?.user)) {
    return <Navigate to={userAccessRoutes.tracking} replace />;
  }

  if (editUserMatch) {
    return <EditUserForm userId={Number(editUserMatch.params.id)} />;
  }
  if (createUserMatch) {
    return <CreateUserForm />;
  }
  if (userDetailsMatch) {
    return <UserDetailsRoute userId={Number(userDetailsMatch.params.id)} />;
  }

  return <UserList />;
}
